import { getCompanyInfo } from "./getCompanyInfo";

/** 开启点击行为日志上报 */
export const isEnableClickLog = () => ['localhost', 'app.cartsee.com'].includes(window.location.hostname);

/** 开启新服务 */
export const isEnableNewService = () => true;

export const isEnableWheelCouponSetting = () => {
  return true;
}

export const isEnablePopupCover = () => {
  return [30, 565, 582, 579, 563, 578, 580, 577, 864, 581, 680, 681, 887, 888, 1339].includes(getCompanyInfo()?.id as number);
};

export const isEnablePrivacySetting = () => {
  return [30, 1738].includes(getCompanyInfo()?.id as number)
}
